"use client";

import { createContext, useContext, useState } from "react";

export interface MobileMenuContextValue {
	mobileOpen: boolean;
	setMobileOpen: React.Dispatch<React.SetStateAction<boolean>>;
	expandedIds: string[];
	setExpandedIds: React.Dispatch<React.SetStateAction<string[]>>;
}

export const MobileMenuContext = createContext<MobileMenuContextValue | null>(null);

/** Returns the shared mobile navigation state, or null outside its provider. */
export function useMobileMenu(): MobileMenuContextValue | null {
	return useContext(MobileMenuContext);
}

/** Provides the mobile navigation open state and submenu path to descendants. */
export function MobileMenuContextProvider({ children }: { children: React.ReactNode }) {
	const [mobileOpen, setMobileOpen] = useState(false);
	const [expandedIds, setExpandedIds] = useState<string[]>([]);

	return <MobileMenuContext.Provider value={{ mobileOpen, setMobileOpen, expandedIds, setExpandedIds }}>{children}</MobileMenuContext.Provider>;
}
